import dotProp from 'dot-prop-immutable';

import * as actionTypes from './actiontypes';
import states from './states';

export default function team_member_setting_details(state = states.team_member_setting_details, action) {
    switch (action.type) {
        case actionTypes.UPDATE_SETTING_STATE: {
            return dotProp.set(state, action.path, action.payload);
        }

        case actionTypes.DELETE_SETTING_STATE: {
            return dotProp.delete(state, action.path);
        }

        case actionTypes.TEAM_MEMBERS_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    team_members_loading: true,
                    team_members_loaded: false,
                }
            };
        }

        case actionTypes.TEAM_MEMBERS_LOADED: {
            return {
                ...state,
                team_members: action.payload.users ? action.payload.users : [],
                loaders: {
                    ...state.loaders,
                    team_members_loading: false,
                    team_members_loaded: true,
                }
            };
        }

        case actionTypes.TEAM_MEMBERS_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    team_members_loading: false,
                    team_members_loaded: false,
                }
            };
        }

        case actionTypes.NEW_MEMBERS_ADDING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    new_member_adding: true,
                }
            };
        }

        case actionTypes.NEW_MEMBERS_ADDED: {
            return {
                ...state,
                team_members: action.payload.users ? [...action.payload.users, ...state.team_members] : [...state.team_members],
                loaders: {
                    ...state.loaders,
                    new_member_adding: false,
                }
            };
        }

        case actionTypes.NEW_MEMBERS_ADDITION_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    new_member_adding: false,
                }
            };
        }

        case actionTypes.REPLACE_MEMBER_OBJECT_IN_TEAM_MEMBERS: {
            let index = -1;
            if (action.payload.user && action.payload.user.length > 0) {
                index = state.team_members.findIndex((member) => { return (member._id === action.payload.user[0]._id) });
            }

            return {
                ...state,
                team_members: index !== -1 ? [...state.team_members.slice(0, index), action.payload.user[0], ...state.team_members.slice(index + 1)] : [...state.team_members],
                loaders: {
                    ...state.loaders,
                    new_member_adding: false,
                }
            };
        }

        case actionTypes.USER_PERMISSIONS_LOADING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    user_permission_loading: true,
                    user_permission_loaded: false,
                }
            };
        }

        case actionTypes.USER_PERMISSIONS_LOADED: {
            return {
                ...state,
                current_member_permissions: action.payload.user ? action.payload.user[0] : {},
                loaders: {
                    ...state.loaders,
                    user_permission_loading: false,
                    user_permission_loaded: true,
                }
            };
        }

        case actionTypes.USER_PERMISSIONS_LOAD_ERROR: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    user_permission_loading: false,
                    user_permission_loaded: false,
                }
            };
        }

        case actionTypes.USER_PERMISSIONS_UPDATING: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    user_permission_updating: true,
                }
            };
        }

        case actionTypes.USER_PERMISSIONS_UPDATION_COMPLETE: {
            return {
                ...state,
                loaders: {
                    ...state.loaders,
                    user_permission_updating: false,
                }
            };
        }

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/data/redux/team_member_setting_details/reducers.js